import { useMemo } from 'react';

import { isNil } from 'lodash';
import { useSelector } from 'react-redux';

import { selectVAStreamById } from '@vlabs/pages/video-analytics/selectors';

const extractCrowdThresholdRules = (stream) => {
  const thresholds = { gte: [], lte: [] };

  stream.analytics
    ?.filter((a) => a?.analytic_name === 'people_count')
    ?.forEach((a) => {
      const params = a.parameters?.parameters ?? {};
      if (!isNil(params.people_count__gte)) thresholds.gte.push(params.people_count__gte);
      if (!isNil(params.people_count__lte)) thresholds.lte.push(params.people_count__lte);
    });

  return thresholds;
};

const mapCrowdThresholdMatchesToLabels = (count, thresholds) => {
  const matched = [];

  thresholds.gte.forEach((value) => {
    if (count >= value) matched.push(`≥ ${value}`);
  });

  thresholds.lte.forEach((value) => {
    if (count <= value) matched.push(`≤ ${value}`);
  });

  return matched;
};

export const usePeopleCountThresholdInfo = (event) => {
  const streamId = event?.event?.stream_id;
  const peopleCount = event?.event?.people_count;

  const stream = useSelector((state) => selectVAStreamById(state, streamId));

  return useMemo(() => {
    if (!stream || peopleCount == null) {
      return { stream: null, thresholds: { gte: [], lte: [] }, matched: [], label: '' };
    }

    const thresholds = extractCrowdThresholdRules(stream);
    const matchedLabels = mapCrowdThresholdMatchesToLabels(peopleCount, thresholds);
    const label = matchedLabels.length ? `${matchedLabels.join(', ')}` : '';

    return {
      stream,
      thresholds,
      matchedLabels,
      label,
    };
  }, [stream, peopleCount]);
};
